import { useState } from "react";
import { useLocation } from "react-router-dom";

import { NO_ACCESS_TYPES, PERMISSIONS } from "../../../../utils/constants";
import { SaveIcon, SupportIcon } from '@heroicons/react/solid'
import Button from "../../../SharedComponents/Button";
import Alert, { ALERT_TYPE } from "../../../Auth/Alert";
import DashboardContainer from "../../../SharedComponents/DashboardContainer";
import Input from "../../../Auth/Input";
import AccessControl from "../../../SharedComponents/AccessControl";
import { editHelpAndSupport } from "../../../../utils/api";

function EditHelpAndSupport() {
    const location = useLocation();

    const [alert, setAlert] = useState('');
    const [alertType, setAlertType] = useState(ALERT_TYPE.ERROR);
    const [title, setTitle] = useState(location.state.helpAndSupportCard.title);
    const [content, setContent] = useState(location.state.helpAndSupportCard.content);
    const [changesMade, setChangesMade] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);

    const handleSave = async () => {
        setSubmitLoading(true);
        try {
            await editHelpAndSupport(title, location.state.helpAndSupportCard.type, content);
            setAlert("Successfully edited Help and Support");
            setAlertType(ALERT_TYPE.SUCCESS);
        } catch (err) {
            setAlert(err.message);
            setAlertType(ALERT_TYPE.ERROR);
        }
        setSubmitLoading(false);
    }

    return (
        <AccessControl requiredPermission={PERMISSIONS.EDIT_HELP_AND_SUPPORT} noAccessType={NO_ACCESS_TYPES.REDIRECT}>
            <DashboardContainer title={"Edit Help and Support"} titleIcon={<SupportIcon className="block h-5 w-5 mr-2" />}>
                <Alert
                    text={alert}
                    type={alertType}
                    active={alert}
                    close={() => setAlert("")}
                />
                <div className="grid xl:grid-cols-8 lg:grid-cols-2 grid-flow-row gap-6 min-h-0">
                    <div className={"xl:col-span-12 col-span-2"}>
                        <div className={
                            "border-0 rounded-lg relative flex flex-col w-full bg-white outline-none " +
                            "focus:outline-none shadow-sm"
                        }>
                            <div className="flex items-start justify-between pt-4 pb-2 px-4 rounded-t">
                                <h3 className="text-md font-medium leading-6 text-indigo-900 ">
                                    <span>Edit {location.state.helpAndSupportCard.type.charAt(0) + location.state.helpAndSupportCard.type.slice(1).toLowerCase()} Card</span>
                                </h3>
                            </div>
                            <div className="px-4">
                                <p className="text-sm text-gray-600">
                                    Use the form below to add the information shown on the {location.state.helpAndSupportCard.type.toLowerCase()} card
                                </p>
                            </div>
                            <div className="relative px-4 flex-auto mt-4 mb-4">
                                <div className={"grid grid-flow-row gap-4 mb-8"}>
                                    <div className={"grid grid-flow-row xl:grid-flow-col gap-4"}>
                                        <Input
                                            type="text"
                                            name="Title"
                                            id="title"
                                            value={title}
                                            onChange={(textInput) => {
                                                setTitle(textInput);
                                                setChangesMade(true);
                                            }}
                                        />
                                        <Input
                                            id="content"
                                            name="Content"
                                            type="text"
                                            value={content}
                                            onChange={(textInput) => {
                                                setContent(textInput);
                                                setChangesMade(true);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={
                                "p-4 bg-gradient-to-l from-primary-50 to-secondary-50 flex items-center justify-end " +
                                "text-right rounded-md"
                            }>
                                <div className="flex flex-row gap-3">
                                    <Button
                                        text="Save changes"
                                        icon={<SaveIcon className="block h-4 w-4 mr-2" />}
                                        iconPositionLeft
                                        onClick={handleSave}
                                        loading={submitLoading}
                                        disabled={!changesMade}
                                        extraStyling={
                                            "text-white focus:ring-inset focus:ring-1 bg-secondary-500 " +
                                            "hover:bg-secondary-600 focus:outline-none focus:ring-secondary-500"
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </DashboardContainer>
        </AccessControl>
    )
}

export default EditHelpAndSupport;
